import axios from 'axios';

export const messageRestaurant = async (params) => {
    return axios.post('/api/message/restaurant', params)
}
export const messageContact = async (params) => {
    return axios.post('/api/message/contact', params)
}